<script setup lang="ts">
import { Separator } from '@collector/shared-ui'
import type {
  EventStatsLevel,
  StatsLevel,
} from '@collector/sportsapi-client-legacy'

defineProps<{
  seasonStatsLevel: StatsLevel
  eventStatsLevel: EventStatsLevel
}>()
</script>

<template>
  <div class="flex items-center text-xs">
    <span>
      Season:
      <span class="font-bold capitalize">
        {{ seasonStatsLevel === 'vip' ? 'VIP' : seasonStatsLevel }}
      </span>
    </span>

    <Separator
      class="mx-2"
      variant="light"
      vertical
    />

    <span>
      Event:
      <span class="font-bold capitalize">
        {{ eventStatsLevel === 'vip' ? 'VIP' : eventStatsLevel }}
      </span>
    </span>

    <Separator
      class="mx-1.5"
      variant="light"
      vertical
    />
  </div>
</template>
